import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function PreventAuth() {
  const location = useLocation();

  if (import.meta.env.VITE_APP_ENVIRONMENT === "local") {
    return <Outlet />;
  }

  if (location.pathname.includes("complete-profile")) {
    return <Outlet />;
  }
  return <Navigate to="/dashboard" replace />;
}
